/**
 * Created by Jasmine on 2019/2/18.
 */
import { observable, action } from "mobx"
import { request, apis } from '../../../utils/net';
import util from '@/utils/util'

class Store {
    @observable step = 0 // 注册步骤

    @observable.shallow userInfo = {} // 用户信息

    @observable industryList = [] // 行业列表

    @observable.shallow packageList = [] // 套餐列表

    @observable.shallow currentPackage = {} // 当前选中套餐

    setStep(step) {
        this.step = step
    }

    @action bindWechat(params) {
        return request({
            url: apis.bindWechat,
            method: 'POST',
            data: params
        })
    }

    /**
     * 获取用户信息
     * @param loginHandler 登录失效处理
     * @return {Promise.<TResult>}
     */
    @action getUserInfo(loginHandler) {
        return request({
            url: apis.getUserInfo,
            //自定义状态码
            ext: {
                codes: ["401"],
                handle: () => {
                    loginHandler && loginHandler()
                }
            },
        }).then(res => {
            this.userInfo = res
            return res
        })
    }

    /**
     * 登录微信
     * @param extHandler 自定义code码处理
     * @return {*}
     */
    @action loginWechat(code, extHandler, wid) {

        return request({
            url: apis.postLoginWeixin,
            method: 'post',
            data: { code, is_register: 1, wid, app_id: util.getAppid() },
            ext: extHandler
        })
    }

    // 获取行业列表
    @action getIndustryList() {
        request({
            url: apis.getIndustryList,
        }).then(res => {
            this.industryList = res
        })
    }

    // 获取短信验证码
    getMobileCode = (mobile) => {
        return request({
            url: apis.getMobileCode,
            method: 'post',
            data: { mobile }
        })
    }

    submitInfo(params) {
        return request({
            url: apis.fillCompanyInfo,
            method: 'post',
            data: params
        }).then(() => {
            this.step = 2
        })
    }

    getPackageList() {
        return request({
            url: apis.SchemeList,
            method: 'post'
        }).then(res => {
            this.packageList = res.schemeList
        })
    }

    setCurrentPackage(index) {
        this.currentPackage = this.packageList[index] || {}
    }

    // 提交套餐
    submitScheme = () => {
        const { id, product_price: amount } = this.currentPackage

        request({
            url: apis.selectScheme,
            method: 'post',
            data: {
                scheme_id: id,
                amount
            },
            ext: {
                // 3,待支付
                codes: ["3"],
                handle: (res) => {
                    this.setState({ visible: true, payData: res.data });
                }
            }
        })
    }

}

export default new Store()
